import { useState, useEffect } from 'react';
import {
  FileExcelOutlined,
  InfoCircleOutlined
} from "@ant-design/icons";
import { Tooltip, Typography, Pagination } from "antd";
import { formatNumber } from "../../../services/mixin";
import { use } from 'echarts';
const { Text } = Typography;

const activities = [
  {
    date: "15/01/2024",
    time: "14:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
  {
    date: "02/01/2024",
    time: "08:00",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "seratima@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin hồ sơ khách hàng",
        vehicles: [
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
    ],
  },
  {
    date: "01/01/2024",
    time: "14:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
  {
    date: "01/01/2024",
    time: "7:20",
    user: "Admin Văn phòng điều hành",
    department: "Phòng Kỹ thuật",
    email: "admin@thacoauto.com.vn",
    actions: [
      {
        text: "Đã tạo thông tin chăm sóc dịch vụ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      {
        text: "Đã tạo thông tin liên hệ",
        vehicles: [
          {
            name: "New Carnival 2.2D Luxury 8S",
            bien: "63A27796",
            khung: "RNYXC54C0SC367949",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
          {
            name: "New Mazda2 1.5 AT",
            bien: "63A28845",
            khung: "RNHA22TDAST008485",
            file: "DDMS_Sale_Bảng kê hợp đồng bán_VinhLong.xls",
          },
        ],
      },
      { text: "Số điện thoại đã được bổ sung 0344735061" },
    ],
  },
];

const UpdateHistory = ({ stData = {} as any, stChange = (data: any) => { } }) => {
  const [obTitle, setObTitle] = useState({} as any);
  useEffect(() => {
    if(stData.sourceColumnWarehouse && stData.sourceColumnWarehouse.customer_history_update && stData.sourceColumnWarehouse.customer_history_update.list) {
      const obj: any = {};
      stData.sourceColumnWarehouse.customer_history_update.list.map((col: any) => {
        obj[col.field] = col.headerName;
      });
      setObTitle(obj);
    }
  }, [stData.sourceColumnWarehouse]);
  const replacePlaceholders = (text: any) => {
    return text.replace(/<\{([^}]+)\}>/g, (match: any, key: any) => {
      return obTitle[key] || match;
    });
  }
  return (
    <>
      <div className="activity-timeline">
        {stData.customers_update_history.map((item: any, index: any) => (
          <div
            key={item.id}
            className={`timeline-item ${index === stData.customers_update_history.length - 1 ? "is-last" : ""}`}
          >
            {/* Line trong item */}
            {index !== stData.customers_update_history.length - 1 && <div className="timeline-line" />}

            {/* Cột thời gian */}
            <div className="timeline-time">
              <Text>{item.date}</Text>
              <br />
              <Text>
                {item.time}
              </Text>
            </div>

            {/* Avatar */}
            <div className="timeline-center">
              <div className="timeline-avatar-icon">
                <img height='100%' src="/logo-full.svg" alt="THACO AUTO CRM" />
              </div>
            </div>

            {/* Nội dung */}
            <div className="timeline-content">
              <div className="timeline-user">
                <Text>{item.user} </Text>
                {/* <span className="cl096DD9 mr-4px">(Đang cập nhật...)</span> */}
                {/* <Text type="secondary">| {item.department}</Text> */}
              </div>
              <div className="timeline-email">{item.email}</div>

              <div className="group-timeline-action">
                {item.actions.map((a: any, i: any) => (
                  <div key={i} className="timeline-action">
                    <span className="text-pre-line-break">{replacePlaceholders(a.text)}</span>
                    {a.vehicles && (
                      <Tooltip
                        placement="right"
                        color="white"
                        overlayClassName="content-tooltip-420-300"
                        title={
                          <div className="t-cotent-p-12">
                            {a.vehicles.map((v: any, vi: any) => (
                              <div key={vi} className="vehicle-item">
                                <div className="vehicle-info">
                                  <div className="vehicle-name">
                                    <Text strong>{v.name}</Text>
                                  </div>
                                  <div className="vehicle-detail">
                                    <div className="cl-344054">
                                      <Text type="secondary">Biển số: </Text>
                                      {v.bien}
                                    </div>
                                    <div className="cl-344054">
                                      <Text type="secondary">Số khung: </Text>
                                      {v.khung}
                                    </div>
                                  </div>
                                  <div className="vehicle-file">
                                    <Text type="secondary">File: </Text>
                                    <FileExcelOutlined className="file-icon" />
                                    {v.file}
                                  </div>
                                </div>
                                <div className="vehicle-arrow">
                                  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.42871 1.35636V2.69564C3.42871 2.78671 3.47335 2.87243 3.54657 2.926L10.5394 7.99922L3.54657 13.0724C3.47335 13.126 3.42871 13.2117 3.42871 13.3028V14.6421C3.42871 14.7581 3.56085 14.826 3.6555 14.7581L12.3359 8.46172C12.6501 8.23314 12.6501 7.76529 12.3359 7.5385L3.6555 1.24207C3.56085 1.17243 3.42871 1.24029 3.42871 1.35636Z" fill="#1890FF" />
                                  </svg>
                                </div>
                              </div>
                            ))}
                          </div>
                        }
                      >
                        <div className="count-number-E6F7FF">
                          3
                          <InfoCircleOutlined className="info-icon" />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {
        stData.customers_update_history.length === 0 && (
          <div className="no-data-block">
            <div className="no-data-text">Không có dữ liệu lịch sử cập nhật</div>
          </div>
        )
      }
      <div className={`t-table-block t-table-customer c-table-scoll-x`}>
        <div className="pagination-block">
          <Pagination
            className='rs-pagination'
            showSizeChanger
            total={stData.customers_update_history_total}
            defaultPageSize={stData.customers_update_history_params_limit}
            current={stData.customers_update_history_params_page}
            pageSizeOptions={['10', '20', '50', '100']}
            itemRender={(page, type, originalElement) => {
              // Chỉ custom khi là nút số trang
              if (type === 'page') {
                return <span>{formatNumber(page)}</span>;
              }
              // prev / next / jump-prev / jump-next giữ nguyên
              return originalElement;
            }}
            showTotal={() => `Tổng cộng ${Math.ceil(stData.customers_update_history_total / stData.customers_update_history_params_limit) === 0 ? 1 : Math.ceil(stData.customers_update_history_total / stData.customers_update_history_params_page)} trang`}
            locale={{ items_per_page: 'trang' }}
            onChange={(page, pageSize) => {
              stChange({
                customers_update_history_params_page: page,
                customers_update_history_params_limit: pageSize,
                customers_update_history_loading: true,
              })
            }}
          />
        </div>
      </div>
    </>
  )
}
export default UpdateHistory
